import {
  ChevronLeft as ChevronLeftIcon,
  Menu as MenuIcon,
} from '@mui/icons-material';
import { Box, CssBaseline, IconButton, Toolbar } from '@mui/material';
import { useEffect, useState } from 'react';
import './App.css';
import CustomBreadcrumbs from './components/breadcrumb/CustomBreadCrumbs';
import MuiAppBar from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import { styled, ThemeProvider } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import AccountSelect from './components/account-select/AccountSelect';
import NavigationItems from './components/navigation-items/NavigationItems';
import UserMenu from './components/user-menu/UserMenu';
import ContainerI18nWrapper from './i18n/I18nWrapper';
import Collapse from '@mui/material/Collapse';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import NavigationIcons from './components/navigation-items/NavigationIcons';
import getTheme from './theme/theme';
import { daDK } from '@mui/x-date-pickers/locales';
//import LanguageSelector from '@/components/user-menu/LanguageSelector';

const drawerWidth = 300;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  // zIndex: theme.zIndex.drawer + 1,
  // zIndex: 1300,
  backgroundColor:
    theme.palette.mode === 'light'
      ? 'rgba(252,252,252,0.50)'
      : 'rgba(33,33,33,0.50)',
  backdropFilter: 'blur(5px)',
  //borderBottom: '1px solid',
  borderColor:
    theme.palette.mode === 'light'
      ? theme.palette.grey[300]
      : theme.palette.grey[800],
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    // marginLeft: drawerWidth,
    // width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  '& .MuiDrawer-paper': {
    position: 'relative',
    backgroundColor:
      theme.palette.mode === 'light' ? '#F5F5F5' : 'hsl(0, 0%, 7%)',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: 'border-box',
    ...(!open && {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(7),
      },
    }),
  },
}));

const getPersistedMode = () => {
  const savedMode = localStorage.getItem('mode');
  return savedMode ? savedMode : 'light';
};

function App() {
  const [open, setOpen] = useState(true);
  const [mode, setMode] = useState(getPersistedMode);

  const toggleColorMode = () => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  useEffect(() => {
    localStorage.setItem('mode', mode);
  }, [mode]);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <ThemeProvider theme={getTheme(mode)}>
      <LocalizationProvider
        dateAdapter={AdapterLuxon}
        adapterLocale="da"
        localeText={
          daDK.components.MuiLocalizationProvider.defaultProps.localeText
        }
      >
        <ContainerI18nWrapper>
          <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Drawer variant="permanent" open={open}>
              {open ? (
                <Collapse orientation="horizontal" in={open}>
                  <NavigationItems />
                </Collapse>
              ) : (
                <NavigationIcons />
              )}
            </Drawer>
            <Box
              component="main"
              sx={{
                backgroundColor: (theme) =>
                  theme.palette.mode === 'light'
                    ? '#FCFCFC'
                    : theme.palette.grey[900],
                flexGrow: 1,
                height: '100vh',
                padding: 0,
                margin: 0,
                overflow: 'auto',
              }}
            >
              <AppBar elevation={0} position="sticky" open={open}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="open drawer"
                    onClick={toggleDrawer}
                    fontSize="small"
                    sx={{
                      marginRight: 1,
                      transition: '0.3s',
                      display: open && 'none',
                      borderRadius: 1,
                    }}
                  >
                    <MenuIcon
                      fontSize="small"
                      sx={{ color: mode === 'light' ? 'black' : 'white' }}
                    />
                  </IconButton>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="open drawer"
                    onClick={toggleDrawer}
                    fontSize="small"
                    sx={{
                      marginRight: 1,
                      transition: '0.3s',
                      display: !open && 'none',
                      borderRadius: 1,
                    }}
                  >
                    <ChevronLeftIcon
                      fontSize="small"
                      sx={{ color: mode === 'light' ? 'black' : 'white' }}
                    />
                  </IconButton>

                  <CustomBreadcrumbs />
                  <AccountSelect openDrawer={setOpen} />

                  {/* <LanguageSelector /> */}
                  <UserMenu mode={mode} toggleColorMode={toggleColorMode} />
                </Toolbar>
              </AppBar>
              <Outlet />
            </Box>
          </Box>
        </ContainerI18nWrapper>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
